import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    const data = this.element.dataset;

    document.addEventListener('DOMContentLoaded', () => {
      if(data.integrationAccessible === 'true' && data.missingAnalyticsView === 'true') {
        const bannerMessage = this.#message();
        app.view_panel.notify(bannerMessage.innerHTML, 'warning dull');
      }

      this.#showLoading();
    });
  }

  #message() {
    const message = 'Reports will not be available for some of your sites until a Google Analytics property is created and connected.';
    const messageContainer = document.createElement('div');

    messageContainer.innerHTML = message;
    const link = this.#getEditLink();
    messageContainer.appendChild(link);

    return messageContainer;
  }

  #getEditLink() {
    const link = document.createElement('a');

    link.href = `/integrations/${this.element.dataset.integrationId}/edit`;
    link.className = 'ga_integration_link';
    link.textContent = 'Connect Sites';
    link.setAttribute('data-remote', 'true');

    return link;
  }

  #showLoading() {
    $(document).on("click", ".ga_integration_link", () => {
      app.view_panel.show_loading();
    });
  }
}
